/**
 * Created by xiajing on 2017/7/11.
 */
import * as types from '../constants/ActionTypes'
let currentCallReqAction = (call,customer) => {
    return {
        type: types.CURRENT_CALL_REQ,
        payload: {call,customer}
    }
}
let currentCallStatus = (status) => {
    return {
        type: types.CURRENT_CALL_STATUS,
        payload: {status}
    }
}
let  showFullScreen = (type) =>{
    return {
        type: types.SHOW_FULL_SCREEN,
        payload:{type}
    }
}
export default {
    currentCallReqAction,
    currentCallStatus,
    showFullScreen
}